import React from 'react';
import RevokeTokenTooltip from './RevokeTokenTooltip';
import _ from 'lodash';
import Text from 'components/base/Text';
import { API_TOKENS_STATUS } from './api-tokens.constants';
import { Tooltip } from '@material-ui/core';
import HideShowCopyTextField from 'components/HideShowCopyTextField/HideShowCopyTextField';
import moment from 'moment';
import { DATE_FORMAT } from 'common/constants/constants';
import RevokeTokenTooltipNoAdmin from './RevokeTokenTooltipNoAdmin';

const getFormattedDate = dateStr => {
  if (dateStr) {
    return moment(dateStr).format(DATE_FORMAT);
  }
  return '-';
};

const RevokeButton = ({ disabled = false, onclick }) => {
  return (
    <Text
      color={disabled ? 'osloGray' : 'chambray'}
      size='large'
      onClick={!disabled && onclick}
      cursor='pointer'
      data-testid={`token-revoke-button-${disabled ? 'disabled' : 'enabled'}`}
      data-cy={`token-revoke-button-data-cy`}
    >
      Revoke
    </Text>
  );
};

export const LabelColumn = ({ apiToken }) => {
  const text = _.get(apiToken, 'label', '-');
  return (
    <Text
      data-testid={`token-label`}
      data-cy={`token-label-data-cy`}
      size='large'
    >
      {text}
    </Text>
  );
};

export const TokenField = ({ apiToken }) => {
  const { prefix } = apiToken;
  return (
    <HideShowCopyTextField
      initiallyVisible={false}
      showVisibilityToggle={false}
      showCopy={false}
      stringLength={32}
      hiddenCharacter={'&middot;'}
      hiddenPrefix={prefix}
    />
  );
};

export const LastAccessedDateColumn = ({ apiToken }) => {
  return (
    <Text
      data-testid={`token-date-last-accessed-at`}
      size='large'
      color='black'
    >
      {getFormattedDate(_.get(apiToken, 'last_accessed_at'))}
    </Text>
  );
};

export const CreatedByColumn = ({ apiToken }) => {
  const dateText = getFormattedDate(_.get(apiToken, 'created_at'));
  return (
    <Text
      data-testid={`token-label-created-by`}
      data-cy='token-label-created-by-data-cy'
      size='large'
    >
      {_.get(apiToken, 'account_name')}
      {`, ${dateText}`}
    </Text>
  );
};
export const ApiTokensActions = ({
  apiToken,
  isAdminAccount,
  onClickRevokeToken,
  apiReleaseDetectionsSettings = [],
  incidentDetectionSettings = []
}) => {
  if (apiToken.status === API_TOKENS_STATUS.REVOKED) {
    return (
      <Text
        data-testid='token-revoked-text'
        data-cy='token-revoked-text-data-cy'
        color='torchRed'
        size='large'
      >
        Revoked
      </Text>
    );
  }

  if (isAdminAccount) {
    const tokenSettings = [
      ...apiReleaseDetectionsSettings,
      ...incidentDetectionSettings
    ]?.filter(item => _.get(item, 'value.api_token_id') === apiToken.id);

    if (!tokenSettings?.length) {
      return <RevokeButton onclick={onClickRevokeToken} />;
    }
    const organizationSettings = tokenSettings?.find(
      item => !Boolean(item.repositoryId)
    );
    const repositoriesName = tokenSettings
      ?.filter(
        item => Boolean(item.repositoryId) && Boolean(item.repository_name)
      )
      .map(item => item.repository_name);
    return (
      <Tooltip
        interactive
        title={
          <RevokeTokenTooltip
            repositoriesName={repositoriesName}
            organizationSettings={organizationSettings}
          />
        }
      >
        <div>
          <RevokeButton disabled={true} />
        </div>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={<RevokeTokenTooltipNoAdmin />}>
      <div>
        <RevokeButton disabled={true} />
      </div>
    </Tooltip>
  );
};
